import { get, post, put } from "../helpers/apihelpers";

export const GetLiveClassService=async(page,text,from_date,to_date)=>{
    try {
        const result = await get(`api/live_class/live_class?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetLiveClassUsersDetailService=async(id)=>{
    try {
        const result = await get(`api/live_class/live_class_detail/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateLiveClassService=async(data,id)=>{
    try {
        const result = await put(`api/live_class/live_class/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const AssignedHandeledByLiveClassService=async()=>{
    try {
        const result = await post(`api/live_class/assigned_handeled_by`,{});
        return result;
    } catch (err) {
        return err.response;
    }
}